import { render } from "./AutoPlay.vue?vue&type=template&id=cdb9c302"
import script from "./AutoPlay.vue?vue&type=script&lang=js"
export * from "./AutoPlay.vue?vue&type=script&lang=js"

import "./AutoPlay.vue?vue&type=style&index=0&id=cdb9c302&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__